import { Model } from '@/js/model/Model';
import Vuex from 'vuex';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';


/**
 * Veux State Initialization
 */
const state = () => ({
  modelID: null,
  modelTitle: 'Loading...',
  modelDescription: '',
  model: {},
  label: '',
  updateKey: null,
  isLoaded: false
});

/**
 * Final Vuex Store Export
 */
export const store = {
  state,
  getters,
  actions,
  mutations  
};